import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const byOrder = (a, b) => (a.order || 0) - (b.order || 0) || (a.name || '').localeCompare(b.name || '', 'ro');

const MobileCategoryGrid = ({ currentCategory }) => {
  const [categories, setCategories] = useState([]);
  const [broken, setBroken] = useState(() => new Set());

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    try {
      // Acelasi arbore ca pe desktop (meniul vertical), plus imagini de produs
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/categories/with-product-images`);
      const data = await response.json();
      setCategories(Array.isArray(data) ? data.filter((c) => c.isActive !== false) : []);
    } catch (error) {
      console.error('Error loading categories:', error);
    }
  };

  const getCategoryImage = (category) => category.productImage || category.image;

  // Cerință client: nu afișăm carduri fără poză reală (nici cu imagini care nu se încarcă)
  const hasImage = (category) => Boolean(getCategoryImage(category)) && !broken.has(category._id);

  const childrenOf = (id) =>
    categories.filter((c) => String(c.parentId) === String(id) && hasImage(c)).sort(byOrder);

  const mainCategories = categories.filter((cat) => !cat.parentId && hasImage(cat)).sort(byOrder);

  const currentCat = categories.find((cat) => cat.slug === currentCategory);
  const parentCat = currentCat?.parentId
    ? categories.find((c) => String(c._id) === String(currentCat.parentId))
    : null;

  // Subcategorii: copiii categoriei curente, iar daca nu are copii, categoriile surori
  const ownChildren = currentCat ? childrenOf(currentCat._id) : [];
  const siblings = parentCat ? childrenOf(parentCat._id) : [];
  const subcategories = ownChildren.length > 0 ? ownChildren : siblings;
  const subTitle = ownChildren.length > 0
    ? `Subcategorii ${currentCat?.name || ''}`
    : parentCat ? `Din ${parentCat.name}` : 'Subcategorii';

  const renderCard = (cat) => (
    <Link key={cat._id} to={`/catalog?category=${cat.slug}`} className="flex-shrink-0">
      <div className={`w-24 bg-white rounded-lg border-2 transition-all ${
        currentCategory === cat.slug ? 'border-green-500 shadow-md' : 'border-gray-200'
      }`}>
        <div className="aspect-square p-2">
          <img
            src={getCategoryImage(cat)}
            alt={cat.name}
            loading="lazy"
            onError={() => setBroken((prev) => new Set(prev).add(cat._id))}
            className="w-full h-full object-cover rounded-md"
            data-testid={`mobile-cat-img-${cat.slug}`}
          />
        </div>
        <div className="px-2 pb-2 text-center">
          <span className={`text-xs font-medium line-clamp-2 ${
            currentCategory === cat.slug ? 'text-green-600' : 'text-gray-900'
          }`}>
            {cat.name}
          </span>
        </div>
      </div>
    </Link>
  );

  return (
    <div className="mb-4 space-y-3">
      <div>
        <h2 className="text-xs font-semibold text-gray-500 uppercase mb-2 px-2">Categorii</h2>
        <div className="flex gap-2 overflow-x-auto pb-2 px-2 scrollbar-hide" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          data-testid="mobile-main-categories">
          {mainCategories.map(renderCard)}
        </div>
      </div>

      {subcategories.length > 0 && (
        <div>
          <h2 className="text-xs font-semibold text-gray-500 uppercase mb-2 px-2">{subTitle}</h2>
          <div className="flex gap-2 overflow-x-auto pb-2 px-2 scrollbar-hide" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
            data-testid="mobile-sub-categories">
            {subcategories.map(renderCard)}
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileCategoryGrid;
